const errorMapping = {
    purchaseRetryFailure: 'We couldn’t complete your subscription. Simply click OK to return to the previous page.',
    planFeaturesAreAlreadyProvided: 'Great news! You already have an active subscription and do not need to buy another one. Simply click OK to proceed to the login page.',
    planIsDisabled: 'This plan is no longer available. Simply click OK to return to the previous page.',
    purchaseIsBanned: 'Purchases are currently unavailable on this account due to that previous payments resulted in a payment dispute. To ensure the security of our company, we are unable to accept further orders from accounts with this history. Click OK to close this message.'
};

const errorMapper = {
    toDomain(error) {
        return {
            ...error,
            message: errorMapping[error.code] || error?.message
        };
    }
};

export {
    errorMapper
};
